/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ForgeServiceDeskEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const forgeServiceDeskEntrypoint: EntryPoint<ForgeServiceDeskEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<ForgeServiceDeskEntrypointComponent>(
			/* webpackChunkName: "async-forge-servicedesk-queue-entrypoint" */ './ForgeServiceDeskQueuePageShellWithAnalyticsMemo.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
